<div class="inline-block py-0.5 px-3 bg-{{ color }}-100 rounded-full w-auto">
  <div class="flex justify-between basis-auto items-center text-sm">
    <span class="mr-2 font-base leading-5 text-{{ color }}-600">{{ label | translate }}</span>
    <span
      class="icon icon-cross text-{{ color }}-600 cursor-pointer"
      (click)="removeChip.emit({ id: id, value: value })"
    ></span>
  </div>
</div>
